import { useEffect, useState } from 'react';

function useFavCard(images) {
  const [isCardFav, setIsCardFav] = useState(false);
  const [favoriteIcon, setFavoriteIcon] = useState(images.ic_inactive_heart);

  const handleCardState = () => {
    isCardFav ? setFavoriteIcon(images.ic_active_heart) : setFavoriteIcon(images.ic_inactive_heart);
  };

  useEffect(() => {
    handleCardState();
  }, [isCardFav]);

  return {
    isCardFav,
    setIsCardFav,
    favoriteIcon,
  };
}

export default useFavCard;
